<template>
    <div class="parent">
      <div class="div1">
        <img src="../assets/total/Logo total.png" alt="Imagen de prueba" />
      </div>
      <div class="div22">
        <img src="../assets/total/Texto 1_1.png" alt="Imagen secundaria" />
      </div>
      <div class="contenedor-centrado">
        <div class="contenedor-imagenes">
          <img class="imagen-aro" src="../assets/total/aro.png" alt="Imagen dentro del contenedor centrado" />
          <img class="imagen-superpuesta animacion-enjuague" src="../assets/total/Enjuague total.png" alt="Nueva imagen superpuesta" />
          <img class="imagen-adicional animacion-cepillo" src="../assets/total/Cepillo total.png" alt="Imagen adicional al lado derecho" />
          <img class="imagen-izquierda animacion-crema" src="../assets/total/crema total.png" alt="Imagen adicional al lado izquierdo" />
        </div>
        <!-- Imágenes laterales existentes -->
        <img class="imagen-lateral-izquierda" src="../assets/total/Banner crema.png" alt="Imagen lateral izquierda" />
        <img class="imagen-lateral-derecha" src="../assets/total/Banner cepillo.png" alt="Imagen lateral derecha" />
        <!-- Imagen inferior existente (Podio) -->
        <img class="imagen-inferior" src="../assets/total/Podio.png" alt="Imagen inferior centrada abajo" />
        <!-- Nueva imagen encima de Podio -->
        <img class="imagen-encima-podio" src="../assets/total/Banner enjuague.png" alt="Nueva imagen encima de podio" />
      </div>
    </div>
  </template>
  
  <script setup>
  import { onMounted } from "vue";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

onMounted(() => {
  const elements = [
    { selector: ".animacion-enjuague", x: 0, y: -1500, rotation: 15, scale: 1.5, duration: 22 },
    { selector: ".animacion-cepillo", x: 300, y: -1300, rotation: -20, scale: 1.4, duration: 20 },
    { selector: ".animacion-crema", x: -300, y: -1200, rotation: 20, scale: 1.3, duration: 19 },
  ];

  elements.forEach((item) => {
    gsap.from(item.selector, {
      x: item.x,
      y: item.y,
      rotation: item.rotation,
      scale: item.scale,
      opacity: 0,
      duration: item.duration, // Tiempo ultra lento (hasta 22s)
      ease: "power1.out", // Movimiento flotante
      scrollTrigger: {
        trigger: ".contenedor-centrado",
        start: "top 60%",
        end: "top 1%",
        scrub: 5, // Control ultra fluido con el scroll
      },
    });
  });
});

  </script>
  
  <style scoped>
  .parent {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(12, 1fr);
    grid-column-gap: 1px;
    grid-row-gap: 1px;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background: url('../assets/total/Fondo.png') no-repeat center center;
    background-size: cover;
    position: relative;
  }
  
  /* Contenedor 1 */
  .div1 {
    grid-area: 1 / 1 / 2 / 4;
    min-height: auto;
    box-sizing: border-box;
    transform: translate(15%, 0);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .div1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  /* Imagen superior derecha */
  .div22 {
    position: absolute;
    top: 5%;
    right: 8%;
    width: 270px;
    height: auto;
    box-sizing: border-box;
  }
  
  .div22 img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  
  /* Contenedor centrado */
  .contenedor-centrado {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    height: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  
  /* Contenedor imágenes internas */
  .contenedor-imagenes {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  /* Imagen aro (base) */
  .imagen-aro {
    width: 100%;
    height: 130%;
    object-fit: contain;
  }
  
  /* Enjuague total */
  .imagen-superpuesta {
    position: absolute;
    top: 50%; /* 50% */
    left: 50%;
    transform: translate(-50%, -50%);
    width: 26%;
    height: auto;
    object-fit: contain;
    pointer-events: none;
  }
  
  /* Cepillo total (derecha) */
  .imagen-adicional {
    position: absolute;
    top: 50%;
    left: calc(50% + 8%);
    transform: translateY(-50%);
    width: 18%;
    height: auto;
    object-fit: contain;
    pointer-events: none;
  }
  
  /* Crema total (izquierda) */
  .imagen-izquierda {
    position: absolute;
    top: 50%;
    left: calc(50% - 14% - 15%);
    transform: translateY(-50%);
    width: 20%;
    height: auto;
    object-fit: contain;
    pointer-events: none;
  }
  
  /* Laterales */
  .imagen-lateral-izquierda {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translateY(-50%);
    width: 23%;
    height: auto;
    object-fit: contain;
  }
  
  .imagen-lateral-derecha {
    position: absolute;
    top: 50%;
    right: 0%;
    transform: translateY(-50%);
    width: 23%;
    height: auto;
    object-fit: contain;
  }
  
  /* Imagen inferior (Podio) */
  .imagen-inferior {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 40%;
    height: auto;
    object-fit: contain;
  }
  
  /* Nueva imagen encima de Podio */
  .imagen-encima-podio {
    position: absolute;
    bottom: 3%; /* Un poco más arriba que Podio */
    left: 50%;
    transform: translateX(-50%);
    width: 28%;
    height: auto;
    object-fit: contain;
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    .parent {
      display: flex;
      flex-direction: column;
      height: auto;
      position: relative;
    }
  
    .div1 {
      width: 100%;
      height: auto;
      transform: none;
    }
  
    .div22 {
      width: 80px;
      padding: 5px;
    }
  
    .contenedor-centrado {
      width: 90%;
      height: 60%;
    }
  
    .imagen-superpuesta {
      width: 25%;
    }
  
    .imagen-adicional {
      left: calc(50% + 12%);
      width: 16%;
    }
  
    .imagen-izquierda {
      left: calc(50% - 12% - 16%);
      width: 16%;
    }
  
    .imagen-lateral-izquierda {
      width: 10%;
      left: 2%;
    }
  
    .imagen-lateral-derecha {
      width: 10%;
      right: 2%;
    }
  
    .imagen-inferior {
      width: 60%;
    }
  
    .imagen-encima-podio {
      width: 50%;
      bottom: 12%;
    }
  }
  </style>
  